module.exports = __webpack_public_path__ + "static/media/iStock-1208690325.b8de2fa2.jpg";